import React, { Component } from 'react';

import { Modal, Form, Button, Input, Grid, Radio, Dropdown } from 'semantic-ui-react';

import PropTypes from 'prop-types';
import moment from 'moment';
import moments from 'moment-timezone';
import styled from 'styled-components';

moments.tz.setDefault('Asia/Seoul');

const defaultContentState = {
  comId: '',
  deletable: false,
  description: '',
  duration: 'day',
  endDate: null,
  endMonth: null,
  endDay: null,
  periodEndMonth: null,
  periodEndDay: null,
  holidayCountryIdx: null,
  idx: null,
  isActive: false,
  isDelete: false,
  name: '',
  startDate: null,
  startMonth: null,
  startDay: null,
  periodStartMonth: null,
  periodStartDay: null,
  updatable: true,
  updateDate: null,
  updateId: null,
  year: null
};

const defaultState = {
  isUpdated: false,
  isDayDisabled: false,
  isPeriodDisabled: true,
  content: defaultContentState
};

const propTypes = {
  item: PropTypes.objectOf(PropTypes.any),
  year: PropTypes.string.isRequired,
  open: PropTypes.bool.isRequired,
  close: PropTypes.func.isRequired
};

const defaultProps = {
  item: defaultContentState
};

class HolidaySaveModal extends Component {
  // getDerivedStateFromProps 호출을 위해 static선언
  // Date => number로 변환
  static toNumber = (item) => {
    if (!item) {
      return {};
    }
    const { duration, startDate, endDate } = item;
    let month = moment(startDate).format('MM');
    let day = moment(startDate).format('DD');
    if (duration === 1) {
      return {
        startMonth: Number(month),
        startDay: Number(day)
      };
    }

    const result = {
      periodStartMonth: Number(month),
      periodStartDay: Number(day)
    };

    month = moment(endDate).format('MM');
    day = moment(endDate).format('DD');

    return {
      ...result,
      periodEndMonth: Number(month),
      periodEndDay: Number(day)
    };
  };

  constructor(props) {
    super(props);
    const month = [];
    const day = [];

    for (let i = 1; i <= 31; i++) {
      const option = { value: i, text: i };
      day.push(option);
      if (i < 13) {
        month.push(option);
      }
    }

    this.state = {
      ...defaultState,
      optionMonth: month,
      optionStartDay: day,
      optionPeriodStartDay: day,
      optionPeriodEndDay: day
    };
  }

  static getDerivedStateFromProps(nextProps, prevState) {
    const { item, open } = nextProps;
    const { content, isUpdated } = prevState;
    let result = null;
    if (open && !item && isUpdated) {
      // 모달이 열릴 때 item이 null이면 추가
      result = {
        ...prevState,
        ...defaultState
      };
    } else if (open && item && item.idx !== content.idx) {
      // 모달이 열릴 때 item이 있고 현재 state idx와 변경될 props의 idx가 다를 경우 수정
      const { duration } = item;
      const toStringDuration = duration > 1 ? 'period' : 'day';
      result = {
        ...prevState,
        isUpdated: true,
        content: {
          ...defaultContentState,
          ...item,
          ...HolidaySaveModal.toNumber(item),
          ...{ duration: toStringDuration }
        }
      };
    }

    return result;
  }

  // 입력
  handleRadioChange = (e, { name, value }) => {
    this.setState((preState) => {
      const { content } = preState;
      let data = { [name]: value };
      let disabled = {};
      if (value === 'day') {
        data = {
          ...data,
          periodStartMonth: null,
          periodStartDay: null,
          periodEndMonth: null,
          periodEndDay: null
        };
        disabled = { isDayDisabled: false, isPeriodDisabled: true };
      } else if (value === 'period') {
        data = {
          ...data,
          startMonth: null,
          startDay: null
        };
        disabled = { isDayDisabled: true, isPeriodDisabled: false };
      }
      return {
        ...preState,
        ...disabled,
        content: { ...content, ...data }
      };
    });
  };

  handleMonthChange = (e, { name, value }) => {
    const { year } = this.props;
    const options = [];

    const changeMonth = moment(`${year}${this.padStartFromNumber(value)}`, 'YYYYMM');

    let endOfMonth = changeMonth.endOf('month').format('DD');
    endOfMonth = Number(endOfMonth);
    for (let i = 1; i <= endOfMonth; i++) {
      options.push({ value: i, text: i });
    }

    if (name === 'startMonth') {
      this.setState({ optionStartDay: options });
    } else if (name === 'periodStartMonth') {
      this.setState({ optionPeriodStartDay: options });
    } else if (name === 'periodEndMonth') {
      this.setState({ optionPeriodEndDay: options });
    }

    this.handleChange(null, { name, value });
  };

  handleChange = (e, { name, value }) => {
    this.setState((preState) => {
      const { content } = preState;
      return {
        content: { ...content, ...{ [name]: value } }
      };
    });
  };

  padStartFromNumber = (dateNumber) => {
    if (!dateNumber) {
      return '';
    }
    return dateNumber.toString().padStart(2, '0');
  };

  // 입력된 콤보 -> date 값으로 변경
  toDate = (content) => {
    if (!content) {
      return {};
    }
    const { year } = this.props;
    const { duration } = content;
    const today = moment();
    // 입력된 값 시간으로 변경
    if (duration === 'day') {
      const startDateString = this.padStartFromNumber(content.startMonth) + this.padStartFromNumber(content.startDay);
      const startDate = moment(`${year}${startDateString}`, 'YYYYMMDD');

      // 금일 및 이전일 입력 불가
      if (startDate.isBefore(today)) {
        return false;
      }

      return {
        startDate,
        endDate: startDate,
        duration: 1
      };
    }
    const periodStartDateString =
      this.padStartFromNumber(content.periodStartMonth) + this.padStartFromNumber(content.periodStartDay);
    const periodStartDate = moment(`${year}${periodStartDateString}`, 'YYYYMMDD');
    const periodEndDateString =
      this.padStartFromNumber(content.periodEndMonth) + this.padStartFromNumber(content.periodEndDay);
    const periodEndDate = moment(`${year}${periodEndDateString}`, 'YYYYMMDD');
    const periodDuration = moment.duration(periodEndDate.diff(periodStartDate)).asDays();

    // validation
    // 금일 및 이전일 입력 불가
    if (periodStartDate.isBefore(today) || periodEndDate.isBefore(today)) {
      return false;
    }

    // 1일 입력 불가 -> 2일 이상의 기간 필요
    if (periodDuration <= 0) {
      return false;
    }
    return {
      startDate: periodStartDate,
      endDate: periodEndDate,
      duration: periodDuration + 1 // 기간 차이 이므로 +1 더함
    };
  };

  save = (operation) => {
    const { close } = this.props;
    const { content } = this.state;
    const {
      startMonth,
      startDay,
      periodStartMonth,
      periodStartDay,
      periodEndMonth,
      periodEndDay,
      duration,
      name
    } = content;

    if (!duration) {
      alert('날짜를 설정해주세요.');
      return;
    }

    if (duration === 'day' && (!startMonth || !startDay)) {
      alert('날짜를 설정해주세요.');
      return;
    }
    if (duration === 'period' && (!periodStartMonth || !periodStartDay || !periodEndMonth || !periodEndDay)) {
      alert('날짜를 설정해주세요.');
      return;
    }

    const changeDate = this.toDate(content);
    if (!changeDate) {
      // 날짜 설정 오류
      alert('날짜의 기간 설정을 다시 확인해주세요.');
      return;
    }
    const item = { ...content, ...changeDate };

    if (!name) {
      alert('공휴일명을 설정해주세요.');
      return;
    }

    close({ operation, item: { ...item } });
    this.setState((prevState) => ({
      ...prevState,
      ...defaultState,
      content: defaultContentState
    }));
  };

  // 취소
  cancel = () => {
    const { close } = this.props;
    this.setState((prevState) => ({
      ...prevState,
      ...defaultState,
      content: defaultContentState
    }));
    close();
  };

  render() {
    const {
      content,
      optionMonth,
      optionStartDay,
      optionPeriodStartDay,
      optionPeriodEndDay,
      isDayDisabled,
      isPeriodDisabled
    } = this.state;
    const { open, item, close } = this.props;
    let isAdd = true;
    let operation = 'add';
    if (item) {
      isAdd = false;
      operation = 'update';
    }

    return (
      <Modal size="small" open={open} onClose={() => this.cancel()}>
        <Modal.Header>공휴일 {isAdd ? '추가' : '수정'}</Modal.Header>

        <Modal.Content className="content-overflow-visible">
          <div>
            <Form className="form-info">
              <Grid>
                <Grid.Row>
                  <Grid.Column width={2} textAlign="left" verticalAlign="middle">
                    <Form.Field inline>
                      <label>
                        날짜 <StyledSpan>*</StyledSpan>
                      </label>
                    </Form.Field>
                  </Grid.Column>
                  <Grid.Column width={2} textAlign="left" verticalAlign="middle">
                    <Radio
                      label="1 일"
                      name="duration"
                      value="day"
                      checked={content.duration === 'day'}
                      onChange={this.handleRadioChange}
                    />
                  </Grid.Column>
                  <Grid.Column width={2} textAlign="center" verticalAlign="middle">
                    <StyledDropdown
                      search
                      selection
                      placeholder="월"
                      name="startMonth"
                      disabled={isDayDisabled}
                      value={content.startMonth}
                      options={optionMonth}
                      onChange={this.handleMonthChange}
                    />
                  </Grid.Column>
                  <Grid.Column width={1} textAlign="center" verticalAlign="middle">
                    /
                  </Grid.Column>
                  <Grid.Column width={2} textAlign="center" verticalAlign="middle">
                    <StyledDropdown
                      search
                      selection
                      placeholder="일"
                      name="startDay"
                      disabled={isDayDisabled}
                      value={content.startDay}
                      options={optionStartDay}
                      onChange={this.handleChange}
                    />
                  </Grid.Column>
                  <Grid.Column width={9}></Grid.Column>
                </Grid.Row>
                <Grid.Row className="form-row">
                  <Grid.Column width={2} textAlign="left" verticalAlign="middle"></Grid.Column>
                  <Grid.Column width={2} textAlign="left" verticalAlign="middle">
                    <Radio
                      label="기간"
                      name="duration"
                      value="period"
                      checked={content.duration === 'period'}
                      onChange={this.handleRadioChange}
                    />
                  </Grid.Column>
                  <Grid.Column width={2} textAlign="center" verticalAlign="middle">
                    <StyledDropdown
                      search
                      selection
                      placeholder="월"
                      name="periodStartMonth"
                      disabled={isPeriodDisabled}
                      value={content.periodStartMonth}
                      options={optionMonth}
                      onChange={this.handleMonthChange}
                    />
                  </Grid.Column>
                  <Grid.Column width={1} textAlign="center" verticalAlign="middle">
                    <p>/</p>
                  </Grid.Column>
                  <Grid.Column width={2} textAlign="center" verticalAlign="middle">
                    <StyledDropdown
                      search
                      selection
                      placeholder="일"
                      name="periodStartDay"
                      disabled={isPeriodDisabled}
                      value={content.periodStartDay}
                      options={optionPeriodStartDay}
                      onChange={this.handleChange}
                    />
                  </Grid.Column>
                  <Grid.Column width={1} textAlign="center" verticalAlign="middle">
                    ~
                  </Grid.Column>
                  <Grid.Column width={2} textAlign="center">
                    <StyledDropdown
                      search
                      selection
                      placeholder="월"
                      name="periodEndMonth"
                      disabled={isPeriodDisabled}
                      value={content.periodEndMonth}
                      options={optionMonth}
                      onChange={this.handleMonthChange}
                    />
                  </Grid.Column>
                  <Grid.Column width={1} textAlign="center" verticalAlign="middle">
                    /
                  </Grid.Column>
                  <Grid.Column width={2} textAlign="center">
                    <StyledDropdown
                      search
                      selection
                      placeholder="일"
                      name="periodEndDay"
                      disabled={isPeriodDisabled}
                      value={content.periodEndDay}
                      options={optionPeriodEndDay}
                      onChange={this.handleChange}
                    />
                  </Grid.Column>
                </Grid.Row>
                <Grid.Row>
                  <Grid.Column width={2} textAlign="left" verticalAlign="middle">
                    <Form.Field inline>
                      <label>
                        공휴일명 <StyledSpan>*</StyledSpan>
                      </label>
                    </Form.Field>
                  </Grid.Column>
                  <Grid.Column width={14} textAlign="left" verticalAlign="middle">
                    <StyledInput
                      name="name"
                      type="text"
                      placeholder="50자까지 입력 가능"
                      minLength="1"
                      maxLength="50"
                      value={content.name}
                      onChange={this.handleChange}
                    />
                  </Grid.Column>
                </Grid.Row>
                <Grid.Row>
                  <Grid.Column width={2} textAlign="left" verticalAlign="middle">
                    <Form.Field inline>
                      <label>설명</label>
                    </Form.Field>
                  </Grid.Column>
                  <Grid.Column width={14} textAlign="left" verticalAlign="middle">
                    <StyledInput
                      name="description"
                      type="text"
                      maxLength="100"
                      placeholder="100자까지 입력 가능"
                      value={content.description}
                      onChange={this.handleChange}
                    />
                  </Grid.Column>
                </Grid.Row>
              </Grid>
            </Form>
          </div>
        </Modal.Content>
        <Modal.Actions>
          <Button inverted className="cancel" color="grey" onClick={this.cancel} content="취소" />
          <Button positive className="ok" content={isAdd ? '추가' : '저장'} onClick={() => this.save(operation)} />
          {isAdd ? (
            <Button positive className="ok" content="계속 추가" onClick={() => this.save('addAndContinue')} />
          ) : null}
        </Modal.Actions>
      </Modal>
    );
  }
}

const StyledInput = styled(Input)`
  &&&& {
    width: 100%;
  }
`;

const StyledDropdown = styled(Dropdown)`
  &&&& {
    min-width: 5em;
    width: 5em;
  }
  ,
  &&&&.disabled {
    background-color: #dcdcdc;
  }
`;

const StyledSpan = styled.span`
  color: red;
`;

HolidaySaveModal.propTypes = propTypes;
HolidaySaveModal.defaultProps = defaultProps;

export default HolidaySaveModal;
